module.exports = __webpack_public_path__ + "static/media/19-speaker_profile.cbb5385c.webp";